import { Provider, APP_INITIALIZER } from '@angular/core';

import { SwiperRegisterService } from '@usheru-hff/shared/ui-swiper';

export function swiperinit(swiperRegisterService: SwiperRegisterService): () => void {
  return () => swiperRegisterService.load();
}

export function provideSwiperLoader(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory: swiperinit,
    deps: [SwiperRegisterService],
    multi: true
  };
}
